module.exports = __webpack_public_path__ + "img/Breadboard_W_evalboard.1fafc50d.png";